export default {
  primaryColor: '#AA103F',
  primary2Color: '#666',
  complementaryColor: '#fff',
  secondaryColor: '#0E7C7B',
  secondaryColor2: '#89BD9E'
};



// WEBPACK FOOTER //
// ./src/parameters/constants.js